export type ScrollCallbackFn = (event: Event, ...rest: Array<any>) => any;

/**
 * @name ScrollService
 *
 * @description Let's you register callbacks for a shared scroll event listener to improve performance
 *
 * @example
 * import { ScrollService } from '@workbench/core';
 *
 * const scrollService = new ScrollService();
 *
 * const scrollFn = (e: Event) => console.log('USER SCROLLED', e);
 *
 * // register listener
 * scrollService.register(scrollFn);
 *
 * // unregister listener
 * scrollService.unregister(scrollFn);
 */
export class ScrollService {
  private registeredCallbacks: Array<ScrollCallbackFn> = [];

  constructor() {
    window.addEventListener('scroll', this.onScroll);
  }

  public register(callback: ScrollCallbackFn): void {
    this.registeredCallbacks.push(callback);
  }

  public unregister(callback: ScrollCallbackFn): void {
    this.registeredCallbacks = this.registeredCallbacks.filter((c) => c !== callback);
  }

  private onScroll = (event: Event): void => {
    this.registeredCallbacks.filter(Boolean).forEach((callback) => callback(event));
  };
}
